export default __webpack_public_path__ + "static/media/spooky_hill_background_xl2.7f23bcf1.jpg";